export default __webpack_public_path__ + "static/media/IMG_5072_min.87a67eb8.png";